import { render, staticRenderFns } from "./MultiWhatsappChannelDetail.vue?vue&type=template&id=fcca7a8e&scoped=true"
import script from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannelDetail.vue?vue&type=style&index=0&id=fcca7a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcca7a8e",
  null
  
)

export default component.exports